import React, { useState, Fragment } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button, SidebarModal, } from "components"
import { deliveryTypeLabels } from "constant"
import OfflineOrderDetails from "./OfflineOrderDetails"
import { getOrderStatusColor, getOrderStatusTitle, moment } from "utils"
import classes from "./OfflineOrderTableRow.module.scss"

const OfflineOrderTableRow = props => {
  const { offlineOrder } = props

  const [t, i18n] = useTranslation()

  const [openOrderDetailsSidebar, setOpenOrderDetailsSidebar] = useState(false)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <tr
        className={classes["item"]}
        onClick={() => setOpenOrderDetailsSidebar(true)}
      >
        <td className={classes["cell"]}>
          <span>{offlineOrder.code}</span>
          {
            !offlineOrder.isViewed &&
            <span
              className={clsx(
                classes["new-badge"],
                isLtr && classes["new-badge-ltr"]
              )}
            >
              {t("جدید")}
            </span>
          }
        </td>

        <td className={clsx(classes["text"], classes["center"])}>
          <span
            className={classes["tag"]}
            style={{
              backgroundColor: getOrderStatusColor(offlineOrder)
            }}
          >
            {t(getOrderStatusTitle(offlineOrder))}
          </span>
        </td>

        <td className={classes["cell"]}>
          <div>{moment().format("jYYYY/jMM/jDD")}</div>
          <div>{moment().format("HH:mm")}</div>
        </td>

        <td className={classes["cell"]}>
          {t(deliveryTypeLabels[offlineOrder.deliveryType])}
        </td>

        <td>
          {offlineOrder.addedBySystem ? offlineOrder.addedByFullName : t("سایت")}
        </td>

        <td className={classes["cell"]}>
          {offlineOrder.order.tableNumber}
        </td>

        <td className={clsx(classes["cell"], classes["center"])}>
          <Button
            onClick={() => setOpenOrderDetailsSidebar(true)}
          >
            {t("مشاهده")}
          </Button>
        </td>
      </tr>

      <SidebarModal
        urlQuery="code"
        urlQueryValue={offlineOrder.code}
        title={`${t("سفارش")} ${offlineOrder.code}`}
        open={openOrderDetailsSidebar}
        onClose={() => setOpenOrderDetailsSidebar(false)}
      >
        <OfflineOrderDetails
          offlineOrder={offlineOrder}
        />
      </SidebarModal>
    </Fragment>
  )
}

export default React.memo(OfflineOrderTableRow)